module.exports = __webpack_public_path__ + "static/media/logo-hsg.b9b74c55.png";